import { Components } from "appworks/components/components";
import { PromptComponent } from "appworks/components/prompt/prompt-component";
import { PromptContent } from "appworks/components/prompt/prompt-content";
import { Layers } from "appworks/graphics/layers/layers";
import { gameState } from "appworks/model/game-state";
import { Services } from "appworks/services/services";
import { State } from "appworks/state-machine/states/state";
import { UIFlag, uiFlags } from "appworks/ui/flags/ui-flags";
import { UpdateFreespinsBetbarCommand } from "slotworks/commands/betbar/update-freespins-betbar-command";
import { BannerComponent } from "slotworks/components/banner/banner-component";
import { CelebrateWinComponent } from "slotworks/components/celebrate-win/celebrate-win-component";
import { slotModel } from "slotworks/model/slot-model";

export class EnterFreespins extends State {
    public onEnter() {
        super.onEnter();

        if (slotModel.read().autoplay.stopOnFeatureWin) {
            Services.autoplay.stop();
        }

        Components.get(CelebrateWinComponent)?.cleanup();
        Components.get(CelebrateWinComponent)?.hide();

        uiFlags.set(UIFlag.PROMPT, true);

        this.showPrompt();
    }

    public complete() {
        this.showFreespinsElements();

        uiFlags.set(UIFlag.PROMPT, false);
        uiFlags.set(UIFlag.FREE_SPINS, true);

        UpdateFreespinsBetbarCommand();

        super.complete();
    }

    // To set up custom options on a prompt, extend this, initialise your prompt and pass it to super
    protected showPrompt(prompt?: PromptContent, loadStage?: number) {
        if (!prompt && Layers.get("Prompts").hasAnyScene(["freespinswin", "freespins"])) {
            prompt = new PromptContent(["freespinswin", "freespins"]);
        }

        if (prompt) {
            const record = gameState.getCurrentGame().getCurrentRecord();

            prompt.setText("winMessage", Services.translations.getFirstValid(
                ["fs.tri", "you_won_x_freespins"],
                { VALUE: record.getFreespinsWon(), freespins: record.getFreespinsWon() }
            ));
            prompt.setText("value", record.getFreespinsWon().toString());
            prompt.addContinueButton("continue");

            Components.get(PromptComponent).showPrompt(prompt, loadStage).then(() => this.complete());

        } else {
            this.complete();
        }
    }

    protected showFreespinsElements() {
        if (Layers.get("Background")?.hasScene("freespins")) {
            Layers.get("Background").setScene("freespins").execute();
        }
        if (Layers.get("MatrixBackground")?.hasScene("freespins")) {
            Layers.get("MatrixBackground").setScene("freespins").execute();
        }
        Components.get(BannerComponent)?.setMode("freespins");
    }
}
